import {useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./contact.css";
import { Mail, Person } from "@material-ui/icons";

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false)


  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_l88xlph",
        "template_tmkdel8",
        formRef.current,
        "BA2f9IjjMC9Bg6bUk"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true)
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="c  profileContent">
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">N'hésitez pas de me contacter</h1>
          <div className="c-info">
            <div className="c-info-item">
            <Person className="icon" />
              +216 28013854
            </div>
            <div className="c-info-item">
            <Mail className="icon" />
              siwarsamaali7@gmail.com
            </div>
          
          </div>
        </div>
        <div className="c-right">
          <p className="c-desc">
         
            <b> Qu'est-ce que vous vouliez réaliser ?</b>Entrer en contact. Toujours disponible pour freelance si le bon projet me présente
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input  type="text" placeholder="Name" name="user_name" />
            <input  type="text" placeholder="Subject" name="user_subject" />
            <input type="text" placeholder="Email" name="user_email" />
            <textarea rows="5" placeholder="Message" name="message" />
            <button>Envoyer</button>
            {done && "Thank you..."}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;